import moment from "moment";


/**
* Si riferisce all'enum omonimo in iperius-one-service\iperius-one-library\Utilities\Utilities_Data.cs"
*/
export const ONEServiceType = {
    DriveImage: 0,
    Cloud: 1,
    Cloud_GoogleDrive: 10,
    Cloud_S3CompatibleStorage: 110,
    Cloud_IperiusS3Storage: 111,
    Cloud_AmazonS3Storage: 112,
    Cloud_Dropbox: 12,
    Cloud_OneDrive: 13,
    Cloud_AzureBlob: 140,
    Cloud_AzureFile: 141,
    FTP: 2,
    HyperV: 3,
    ESXi: 4,
    Microsoft: 5,
    Microsoft_ExchangeOnPremises: 50,
    Microsoft_ExchangeOnPremisesEWS: 51,
    Microsoft_Exchange365: 52,
    Microsoft_SharePoint: 53,
    Microsoft_Teams: 54,
    Microsoft_OneDriveForBusiness: 55,
    Database: 6,
    Database_SQLServer: 60,
    Database_MySQL: 61,
    FileFolder: 8,
    Network: 81,
    Email: 7,
    Email_GMail: 70,
    Email_Outlook: 71,
    Email_Yahoo: 72,
    Email_ICloud: 73,
    Email_AoL: 74
}

const allClouds = [ONEServiceType.Cloud_AmazonS3Storage, ONEServiceType.Cloud_S3CompatibleStorage, ONEServiceType.Cloud_IperiusS3Storage, ONEServiceType.Cloud_AzureBlob, ONEServiceType.Cloud_AzureFile, ONEServiceType.Cloud_Dropbox, ONEServiceType.Cloud_GoogleDrive, ONEServiceType.Cloud_OneDrive];


export const ONEServiceTypeInfo = {
    8: {
        type: 8,
        mainType: -1,
        mainTypeName: "File/Folder",
        name: "Local File/Folder",
        icon: require("../../public/assets/img/icons/file-folder.svg"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network, ONEServiceType.FTP].concat(allClouds),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: false,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: true,
        forRestoreFileDestination: true,
        enabled: true,
        needed_service_account: false,
        forDownloadItems: false,
        isRestoreActive: true,
        slash: "\\"
    },
    81: {
        type: 81,
        mainType: -1,
        mainTypeName: "File/Folder",
        name: "Network Folder",
        icon: require("../../public/assets/img/icons/network.svg"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network, ONEServiceType.FTP].concat(allClouds),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: true,
        forBackupDestination: true,
        forRestoreFileDestination: true,
        enabled: true,
        needed_service_account: false,
        forDownloadItems: true,
        isRestoreActive: true,
        slash: "\\"
    },
    0: {
        type: 0,
        mainType: -1,
        mainTypeName: "Disks & Virtual Machines",
        name: "Drive Image",
        icon: require("../../public/assets/img/icons/driveimage.png"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network, ONEServiceType.FTP].concat(allClouds),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: false,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        enabled: true,
        needed_service_account: false,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "\\"
    },
    1: {
        type: 1,
        mainType: -1,
        name: "Cloud",
        icon: require("../../public/assets/img/icons/cloud-icon.svg"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    10: {
        type: 10,
        mainType: 1,
        mainTypeName: "Cloud",
        name: "Google Drive",
        icon: require("../../public/assets/img/icons/googledrive.png"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    110: {
        type: 110,
        mainType: 1,
        mainTypeName: "Cloud",
        name: "S3 Compatible",
        icon: require("../../public/assets/img/icons/amazon-s3.svg"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    111: {
        type: 111,
        mainType: 1,
        mainTypeName: "Cloud",
        name: "Iperius Storage S3",
        icon: require("../../public/assets/img/icons/storage_logo_grigio.png"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    112: {
        type: 112,
        mainType: 1,
        mainTypeName: "Cloud",
        name: "Amazon S3",
        icon: require("../../public/assets/img/icons/amazon-s3.svg"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    12: {
        type: 12,
        mainType: 1,
        mainTypeName: "Cloud",
        name: "Dropbox",
        icon: require("../../public/assets/img/icons/dropbox.svg"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    13: {
        type: 13,
        mainType: 1,
        mainTypeName: "Cloud",
        name: "OneDrive",
        icon: require("../../public/assets/img/icons/onedrive.svg"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    140: {
        type: 140,
        mainType: 1,
        mainTypeName: "Cloud",
        name: "Azure Blob",
        icon: require("../../public/assets/img/icons/azure-blob.svg"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    141: {
        type: 141,
        mainType: 1,
        mainTypeName: "Cloud",
        name: "Azure File",
        icon: require("../../public/assets/img/icons/azure-file.svg"),
        needSocketConnection: false, //gli elementi vengono recuperati tramite chiamate API
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    2: {
        type: 2,
        mainType: -1,
        mainTypeName: "File/Folder",
        name: "FTP",
        icon: require("../../public/assets/img/icons/ftp-icon.svg"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: true,
        forBackupSource: false,
        forBackupDestination: true,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: false,
        slash: "/"
    },
    3: {
        type: 3,
        mainType: -1,
        mainTypeName: "Disks & Virtual Machines",
        name: "Hyper-V",
        icon: require("../../public/assets/img/icons/hyper-v.png"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network].concat(allClouds),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: false,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: false,
        forDownloadItems: false,
        isRestoreActive: true,
        slash: "\\"
    },
    4: {
        type: 4,
        mainType: -1,
        mainTypeName: "Disks & Virtual Machines",
        name: "ESXi",
        icon: require("../../public/assets/img/icons/esxi-logo.png"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false, //Nel primo rilascio di Enterprise, viene ignorato
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "\\"
    },
    5: {
        type: 5,
        mainType: -1,
        name: "Microsoft 365",
        icon: require("../../public/assets/img/icons/microsoft.svg"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: true,
        slash: "/"
    },
    50: {
        type: 50,
        mainType: 5,
        mainTypeName: "Microsoft 365",
        name: "Exch On Premises",
        icon: require("../../public/assets/img/icons/exchange.png"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    51: {
        type: 51,
        mainType: 5,
        mainTypeName: "Microsoft 365",
        name: "Exch.On Prem.(EWS)",
        icon: require("../../public/assets/img/icons/exchange.png"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    52: {
        type: 52,
        mainType: 5,
        mainTypeName: "Microsoft 365",
        name: "Exchange 365",
        icon: require("../../public/assets/img/icons/Microsoft Exchange.svg"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: true,
        slash: "/"
    },
    53: {
        type: 53,
        mainType: 5,
        mainTypeName: "Microsoft 365",
        name: "SharePoint",
        icon: require("../../public/assets/img/icons/ms-sharepoint.svg"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: true,
        slash: "/"
    },
    54: {
        type: 54,
        mainType: 5,
        mainTypeName: "Microsoft 365",
        name: "Microsoft Teams",
        icon: require("../../public/assets/img/icons/teams.svg"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: true,
        slash: "/"
    },
    55: {
        type: 55,
        mainType: 5,
        mainTypeName: "Microsoft 365",
        name: "OneDrive for business",
        icon: require("../../public/assets/img/icons/onedrive.svg"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: true,
        isRestoreActive: true,
        slash: "/"
    },
    6: {
        mainType: -1,
        name: "Database",
        icon: require("../../public/assets/img/icons/database.png"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        enabled: true,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    60: {
        type: 60,
        mainType: -1, //6,
        mainTypeName: "Database",
        name: "SQL Server",
        icon: require("../../public/assets/img/icons/Microsoft_SqlServer.png"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: true,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: true,
        slash: "/"
    },
    61: {
        type: 61,
        mainType: 6, //6,
        mainTypeName: "Database",
        name: "MySQL",
        icon: require("../../public/assets/img/icons/mysqldatabase.png"),
        backupDestinationTypes: [ONEServiceType.FileFolder, ONEServiceType.Network],
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: true,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    7: {
        mainType: -1,
        name: "Email",
        icon: require("../../public/assets/img/icons/email-icon.png"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: false,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    70: {
        type: 70,
        mainType: 7,
        mainTypeName: "Email",
        name: "Gmail",
        icon: require("../../public/assets/img/icons/gmail.png"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: false,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    71: {
        type: 71,
        mainType: 7,
        mainTypeName: "Email",
        name: "Outlook",
        icon: require("../../public/assets/img/icons/outlook.png"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: false,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    72: {
        type: 72,
        mainType: 7,
        mainTypeName: "Email",
        name: "Yahoo",
        icon: require("../../public/assets/img/icons/yahoo.png"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: false,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    73: {
        type: 73,
        mainType: 7,
        mainTypeName: "Email",
        name: "iCloud",
        icon: require("../../public/assets/img/icons/icloud.png"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: false,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    },
    74: {
        type: 74,
        mainType: 7,
        mainTypeName: "Email",
        name: "AOL",
        icon: require("../../public/assets/img/icons/aol.png"),
        needSocketConnection: true, //gli elementi vengono recuperati dall'agent
        forServiceAccount: true,
        forRepository: false,
        forBackupSource: false,
        forBackupDestination: false,
        forRestoreFileDestination: false,
        enabled: false,
        needed_service_account: true,
        forDownloadItems: false,
        isRestoreActive: false,
        slash: "/"
    }
};


//...\iperius-enterprise-agent\IperiusEWP\BackupSources\FileFolder\Core\Utils\Enums.cs
export const FileFolderEntityType = {
    FN_File: 0,
    FN_Folder: 1,

    Cloud_Root: 2,
    Cloud_Bucket: 3,
    Cloud_File: 4,
    Cloud_Folder: 5,

    SP_Site_All: 6,
    SP_File: 7,
    SP_Folder: 8,
    SP_Site: 9,
    SP_Library: 10,

    MT_Team: 11,
    MT_Channel: 12,
    MT_PostSection: 13,
    MT_UserChat: 14,

    EX_Note: 15,
    EX_Appointment: 16,
    EX_Contact: 17,
    EX_Task: 18,
    EX_OtherItem: 19,

    FTP_File: 20,
    FTP_Folder: 21,
    CloudAccount: 22,

    MT_Team_All: 23,

    Database: 24,
    Disk: 25,
    DiskPartition: 26,
    VirtualMachine: 27,

    Mailbox_User: 28,
    Mailbox_Impersonation: 29,
    Mailbox_Group: 30,
    Mailbox_Shared: 31,

    CloudAccount_All: 32,
    Mailbox_All: 33,

    MT_Team_AllTeams: 34,

}
/**
* Si riferisce all'enum omonimo in : iperius-one-service\iperius-one-library\Utilities\Utilities_Data.cs"
*/
export const ResultValue = {
    Error: 0,
    OK: 1,
    SomeWarnings: 2,
    Running: 3,
    Aborted: 4,
    //JobNotNeeded: 5,
    NeverExecuted: 99,
    TerminatedAbnormally: 6,
    FeatureNotEnabled: 7
}


export const SystemInfoType = {
    OS_VERSION: 10,
    OS_NAME: 11,
    OS_ARCHITECTURE: 12,
    OS_BUILD_NUMBER: 13,
    ANTIVIRUS: 20,
    WINDOWS_DEFENDER_STATUS: 21,
    FIREWALL: 22,
    WINDOWS_FIREWALL_STATUS: 23,
    ANTI_SPYWARE: 24,
    DOMAIN: 30,
    IS_PART_OF_DOMAIN: 31,
    DOMAIN_ROLE: 32,
    HYPER_V_INSTALLED: 40,
    SQL_INSTANCES_INSTALLED: 41,
    OS_PATCHES_ALERT: 92

}



export const fileExtensions = {
    "Images": [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".tiff", ".webp", ".heic", ".heif", ".svg", ".ico"],
    "Documents": [".pdf", ".doc", ".docx", ".txt", ".rtf", ".xls", ".xlsx", ".csv", ".ppt", ".pptx", ".log", ".md", ".odt", ".ods", ".odp"],
    "Audio": [".mp3", ".wav", ".flac", ".aac", ".ogg", ".m4a", ".wma", ".aiff", ".aif", ".opus"],
    "Video": [".mp4", ".avi", ".mkv", ".mov", ".flv", ".webm", ".m4v", ".wmv", ".mpeg", ".mpg", ".3gp"],
    "Archives": [".zip", ".rar", ".tar", ".gz", ".7z", ".tgz", ".bz2", ".xz", ".iso"],
    "Source code": [
        // Web
        ".html", ".htm", ".css", ".js", ".jsx", ".ts", ".tsx", ".json", ".xml",
        ".php", ".phtml",

        // Backend / scripting
        ".py", ".rb", ".pl", ".sh", ".bash",
        ".ps1", ".psm1",
        ".lua",

        // Java / JVM
        ".java", ".kt", ".kts", ".groovy",
        ".class", ".jar", ".war",

        // .NET / C#
        ".cs", ".csproj", ".vb", ".vbproj",
        ".fs", ".fsproj",
        ".sln", ".dll", ".exe", ".aspx",

        // C / C++
        ".c", ".h", ".cpp", ".hpp", ".cc", ".cxx",

        // Go / Rust
        ".go", ".rs",

        // Swift / Apple
        ".swift",

        // Mobile
        ".dart",        // Flutter
        ".gradle",

        // Database / query
        ".sql",

        // Build / config
        ".yml", ".yaml", ".ini", ".cfg", ".conf",
        ".toml", ".env",

        // Scripts & misc
        ".bat", ".cmd", ".makefile", ".mk",

        // Package / dependency
        ".lock", ".npmignore", ".composer",

        // Assembly / low-level
        ".asm", ".s"
    ]
}

export const iconsToModuleEnabled = {
    //License attualmente messe sulla tabella tipi_license
    //ID VECCHI
    /* License attualmente messe sulla tabella tipi_license
        300	Virtual Machines
        400	Microsoft 365
        500	Database
        600	Tape
        700	Monitoring
        800	Standard
        */
    300: '/assets/img/icons/license_icons/VM_black.svg',
    400: '/assets/img/icons/license_icons/M365_black.svg',
    500: '/assets/img/icons/license_icons/database_black.svg',
    600: '/assets/img/icons/license_icons/tape_black.svg',
    700: '/assets/img/icons/license_icons/istogram_black.svg',
    800: '/assets/img/icons/license_icons/folder_black.svg',
    //06/08/2025: aggiunta moduli
    //"30001":"",//ID_MAIN_LICENSE_ONE -> Prossimamente
    //"30002":"",//ID_MAIN_LICENSE_ONE_UPGRADE -> Prossimamente
    "30100": "/assets/img/icons/license_icons/istogram_black.svg",//ID_MODULO_ONE_RMM
    "30200": "/assets/img/icons/license_icons/folder_black.svg",//ID_MODULO_ONE_ESSENTIAL
    "30300": "/assets/img/icons/license_icons/database_black.svg",//ID_MODULO_ONE_DATABASE
    "30400": "/assets/img/icons/license_icons/VM_black.svg",//ID_MODULO_ONE_HYPERV
    //"30500":"",//ID_MODULO_ONE_VMWARE -> Prossimamente
    //"30600":"",//ID_MODULO_ONE_PROXMOX -> Prossimamente
    "30700": "/assets/img/icons/license_icons/M365_black.svg",//ID_MODULO_ONE_MICROSOFT_365
    //"30800":"/assets/img/icons/license_icons/antivirus1_black.svg",//ID_MODULO_ONE_ANTIVIRUS -> Prossimamente
    "30900": "/assets/img/icons/logo_remote.svg",//ID_MODULO_ONE_REMOTE_ACCESS
    //"31000":"" //ID_MODULO_TICKETING PROSSIMAMENTE

};
export const iconsToModuleDisabled = {
    /* License attualmente messe sulla tabella tipi_license*/
    //ID VECCHI
    /* License attualmente messe sulla tabella tipi_license
    300	Virtual Machines
    400	Microsoft 365
    500	Database
    600	Tape
    700	Monitoring
    800	Standard
    */
    300: '/assets/img/icons/license_icons/VM_grey.svg',
    400: '/assets/img/icons/license_icons/M365_grey.svg',
    500: '/assets/img/icons/license_icons/database_grey.svg',
    600: '/assets/img/icons/license_icons/tape_grey.svg',
    700: '/assets/img/icons/license_icons/istogram_grey.svg',
    800: '/assets/img/icons/license_icons/folder_grey.svg',
    //06/08/2025: aggiunta moduli
    //"30001":"",//ID_MAIN_LICENSE_ONE -> Prossimamente
    //"30002":"",//ID_MAIN_LICENSE_ONE_UPGRADE -> Prossimamente
    "30100": "/assets/img/icons/license_icons/istogram_grey.svg",//ID_MODULO_ONE_RMM
    "30200": "/assets/img/icons/license_icons/folder_grey.svg",//ID_MODULO_ONE_ESSENTIAL
    "30300": "/assets/img/icons/license_icons/database_grey.svg",//ID_MODULO_ONE_DATABASE
    "30400": "/assets/img/icons/license_icons/VM_grey.svg",//ID_MODULO_ONE_HYPERV
    //"30500":"",//ID_MODULO_ONE_VMWARE -> Prossimamente
    //"30600":"",//ID_MODULO_ONE_PROXMOX -> Prossimamente
    "30700": "/assets/img/icons/license_icons/M365_grey.svg",//ID_MODULO_ONE_MICROSOFT_365
    //"30800":"/assets/img/icons/license_icons/antivirus1_grey.svg",//ID_MODULO_ONE_ANTIVIRUS -> Prossimamente
    "30900": "/assets/img/icons/logo_remote.svg",//ID_MODULO_ONE_REMOTE_ACCESS
    //"31000":"" //ID_MODULO_TICKETING PROSSIMAMENTE
};


/**
* Veronica: Ho racchiuso in una singola mappa tutte le funzioni dell'orderBy, per una maggiore accessibilità
* - Molte funzioni sono simili ad altre, quindi ci sono alcune che richiamano altri casi
* - Le funzioni DESC sono semplicemente quelle ASC al contrario, quindi viene richiamata prima ASC, poi ne viene ribaltato il risultato
* - Le funzioni che riguardano una data sono le stesse, quindi di base per tutte uso l'implementazione di DATE_ASC
*/
export const OrderBy = {
    "UNSPECIFIED": {
        label: "",
        apply: (list) => [list.toMap("id"), list]
    },
    "NAME_ASC": {
        label: "Name : A-Z",
        apply: (list) => {
            var names_of_name_params = ["name", "title"];
            var name_param = names_of_name_params.find(n => list[0][n] != undefined);
            if (!name_param) {
                return OrderBy.UNSPECIFIED.apply(list);
            }

            list.sort((a, b) => a[name_param] <= b[name_param] ? -1 : 1);

            return [list.toMap("id"), list];
        }
    },
    "NAME_DESC": {
        label: "Name : Z-A",
        apply: (list) => {
            var [_, newList] = OrderBy.NAME_ASC.apply(list);
            newList = newList.reverse();
            return [newList.toMap("id"), newList];
        }
    },
    "DATE_ASC": {
        label: "Date : from least to most recent",
        apply: (list, dateTemplate) => {
            var names_of_date_params = ["date", "dt_start_utc", "lastDeploymentChangeTime"];

            var name_param = names_of_date_params.find(n => list[0][n] != undefined);
            if (!name_param) {
                return OrderBy.UNSPECIFIED.apply(list);
            }
            var nullDate_list = list.filter(x => [null, ""].includes(x[name_param]));
            var notNUllDate_list = list.filter(x => ![null, ""].includes(x[name_param])).sort((a, b) => moment(a[name_param], dateTemplate).toDate() <= moment(b[name_param], dateTemplate).toDate() ? -1 : 1);
            list = nullDate_list.concat(notNUllDate_list);

            return [list.toMap("id"), list];
        }
    },
    "DATE_DESC": {
        label: "Date : from most to least recent",
        apply: (list, dateTemplate) => {
            var [_, newList] = OrderBy.DATE_ASC.apply(list, dateTemplate);
            newList = newList.reverse();
            return [newList.toMap("id"), newList];
        }
    },
    "INSTALLED_NOT_INSTALLED": {
        label: "Installed - Not installed",
        apply: (list) => {
            list.sort(x => x.isInstalled ? -1 : 1);
            return [list.toMap("id"), list];
        }
    },
    "NOT_INSTALLED_INSTALLED": {
        label: "Not installed - Installed",
        apply: (list) => {
            var [_, newList] = OrderBy.INSTALLED_NOT_INSTALLED.apply(list);
            newList = newList.reverse();
            return [newList.toMap("id"), newList];
        }
    },
    "SEVERITY_ASC": {//Low, Moderate, Important, Critical
        label: "Severity : from least to most critical",
        apply: (list) => {
            const severityOrder = {
                null: -1,
                "Unspecified": 0,
                "Low": 1,
                "Moderate": 2,
                "Important": 3,
                "Critical": 4
            };

            list.sort((a, b) => {
                const aValue = severityOrder[a.severity] ?? severityOrder[null];
                const bValue = severityOrder[b.severity] ?? severityOrder[null];
                return aValue - bValue;
            });

            return [list.toMap("id"), list];

        }
    },
    "SEVERITY_DESC": {
        label: "Severity : from most to least critical",
        apply: (list) => {
            var [_, newList] = OrderBy.SEVERITY_ASC.apply(list);
            newList = newList.reverse();
            return [newList.toMap("id"), newList];
        }
    },
    "LAST_UPDATE_ASC": {
        label: "Last update : from least to most recent",
        apply: (list, dateTemplate) => OrderBy.DATE_ASC.apply(list, dateTemplate)
    },
    "LAST_UPDATE_DESC": {
        label: "Last update : from most to least recent",
        apply: (list, dateTemplate) => OrderBy.DATE_DESC.apply(list, dateTemplate)

    }



}

/**
 * Questo oggetto:
 * - Simula la classe "\iperius-one-service\iperius-one-library\Models\PipeModels\RtModels.cs - ClientMessage"
 * - è un helper per costruire un ClientMessage corretto.
 * 
 */
export const ClientMessage = {
    get: function (text, msgType, msgArgs, isToast, isTranslated, command) {
        msgType = msgType.toUpperCase();
        if (msgArgs && Array.isArray(msgArgs)) {
            msgArgs = { ...msgArgs };
        }
        var textColor, msgIconClass;
        switch (msgType) {
            case "SUCCESS":
            case "OK":
                textColor = 'fg-green';
                msgIconClass = "mif-checkmark";
                break;
            case "ALERT":
            case "ERROR":
                textColor = 'fg-red';
                msgIconClass = "mif-cross";
                break;
            case "WARNING":
                textColor = "fg-orange";
                msgIconClass = "mif-warning";
                break;
            case "STEP":
            case "WAIT":
                textColor = 'fg-cobalt';
                msgIconClass = "mif-spinner2 ani-spin";
                break;
            default:
                textColor = 'fg-cobalt';
                msgIconClass = "";
                break;
        }
        return {
            "text": text,
            "msgType": msgType,
            "msgArgs": msgArgs,
            "textColor": textColor,
            "msgIconClass": msgIconClass,
            "isToast": isToast,//Mostrerà come toast solo i messaggi di errore o di buona riuscita dell'operazione
            "isTranslated": isTranslated,
            "isFeedbackMessage": true,
            "command": command
        };
    },
    getToast: function (text, msgType, msgArgs, command) {
        return this.get(text, msgType, msgArgs, true, false, command);
    },
    wait: function (text, msgArgs, command) {
        return this.get(text, "WAIT", msgArgs, false, false, command);
    },
    wait_translated: function (text, msgArgs, command) {
        return this.get(text, "WAIT", msgArgs, false, true, command);
    },
    error: function (text, msgArgs, command, isToast = true) {
        return this.get(text, "ERROR", msgArgs, isToast, false, command);
    },
    error_translated: function (text, msgArgs, command, isToast = true) {
        return this.get(text, "ERROR", msgArgs, isToast, true, command);
    },
    success: function (text, msgArgs, command, isToast = true) {
        return this.get(text, "SUCCESS", msgArgs, isToast, false, command);
    },

    warning: function (text, msgArgs, command) {
        return this.get(text, "WARNING", msgArgs, false, false, command);
    },
    warning_translated: function (text, msgArgs, command) {
        return this.get(text, "WARNING", msgArgs, false, true, command);
    },

    info: function (text, msgArgs, command) {
        return this.get(text, "INFO", msgArgs, false, false, command);
    },
    info_translated: function (text, msgArgs, command) {
        return this.get(text, "INFO", msgArgs, false, true, command);
    },
    fromAgent: function (agentMsg) {
        return this.get(agentMsg.text, agentMsg.msgType, agentMsg.msgArgs, agentMsg.isToast, agentMsg.isTranslated, agentMsg.command);
    }
}

/**
 * Questo oggetto:
 * - Simula la classe "\iperius-one-service\iperius-one-library\Models\PipeModels\RtModels.cs - TestResult"
 * - è un helper per costruire un TestResult corretto.
 * 
 */
export const TestResult = {
    getSuccess: function (serviceAccount, client) {
        if (!client) {
            client = {
                "serviceAccount": serviceAccount
            };
        }
        return {
            "ok": true,
            "okNumber": 1,
            "serviceAccount": serviceAccount,
            "client": client
        }
    },

    getFailed: function () {
        return {
            "ok": false,
            "okNumber": 0,
            "serviceAccount": null,
            "client": null
        }
    }
}

export const AuditLogsHelper = {
    /* DAL SERVER
    {
        "activity":"UPDATE",
        "args":{},
        "category":"USER",
        "details":"User \"{ID_USER}\" updated user \"{ID_USER}\"",
        "dt_log":"2025-11-10T17:09:30Z",
        "id_activity":2,
        "id_category":1,
        "id_log":"fdd10222-a995-4918-ba87-977ece09aa1a",
        "id_user":"138a2a2d-0b4b-4fff-911f-1eb74a71889a",
        "ip_address":"185.6.241.138",
        "user_agent":"",
        "username":"a.foresi"
    }
    */
    //11/11/2025: NON SO SE QUESTO METODO SERVE
    create: function (id_user, username, ip_address, id_category, category, id_activity, activity, details, args) {
        return {
            "id_user": id_user,
            "username": username,
            "ip_address": ip_address,

            "id_category": id_category,
            "category": category,

            "id_activity": id_activity,
            "activity": activity,

            "details": details,
            "args": args
        }
    },

    forAPIRequest(auditObj) {
        return {
            "id_activity": auditObj.id_activity,
            "id_user": auditObj.id_user,
            "args": auditObj.args
        }
    }
}


export const DateHelper = {
    FORMATS: [
        "YYYYMMDDHHmmss",           // 20260123153045
        moment.ISO_8601             // 2026-01-23T15:30:45Z / 2026-01-23T15:30:45.000Z / ecc
    ],

    parseUtc: function (input) {
        if (!input || typeof input !== "string") return null;

        const s = input.trim();

        // Se è "compact", forziamo quel formato; altrimenti lasciamo ISO_8601.
        const isCompact = /^\d{14}$/.test(s);

        const m = isCompact
            ? moment.utc(s, "YYYYMMDDHHmmss", true)     // strict
            : moment.utc(s, moment.ISO_8601, true);     // strict ISO

        return m.isValid() ? m : null;
    },

    // Ritorna un Date (istante corretto). Quando lo stampi/usi, è in locale.
    toLocalDate: function (input) {
        const m = this.parseUtc(input);
        return m ? m.local().toDate() : null;
    },

    // Ritorna stringa formattata in locale con formato "LLLL"
    toPrettyDate: function (input) {
        const m = this.parseUtc(input);
        if (!m) return "";
        const ml = m.clone().local();
        return ml.local().format("LLLL");
    },

    toSimpleDateString: function (input, i18nLocale) {
        const locale = this.getCurrentLocale(i18nLocale);

        // moment spesso vuole solo la lingua base (it, en, de), ma accetta anche it-IT se presente
        const momentLocale = locale.split("-")[0];

        moment.locale(momentLocale);

        // L = data locale, LTS = ora locale con secondi (locale-aware)
        return moment(input).format("L LTS");
    },
    getCurrentLocale(i18nLocale) {
        // Compat: vue-i18n v9 (Composition/legacy) e v8
        const raw = i18nLocale;

        // In v9 può essere ref, in v8 stringa
        const locale = typeof raw === "string" ? raw : raw?.value;

        // normalizza: it_IT -> it-IT
        return (locale || "en").replace("_", "-");
    },

    // Se ti serve anche il Moment locale pronto
    toLocalMoment(input) {
        const m = this.parseUtc(moment, input);
        return m ? m.local() : null;
    }
}


export const ScriptsHelper = {
    languagesValues: {
        "powershell": "Powershell",
        /*"bash": "Bash",*/
        "cmd": "CMD"
    },
    osValues: {
        "windows": "Windows",
        /*"mac": "Mac",
        "linux": "Linux"*/
    },
    statusValues: { "draft": "Draft", "testing": "In progress", "approved": "Approved" },
    scriptDeployResult: {
        "pending": "Script deploy pending",     // deploy lanciato lato server ma non ancora ricevuto dall'agent
        "deployed": "Script deploy deployed",   // deploy ricevuto dall'agent
        "success": "Script deploy successful",  // terminato con exit code 0
        "failed": "Script deploy failed",        // terminato con exit code != 0
        "timeout": "Script deploy timed out",    // processo avviato ma ucciso allo scadere del timeout
        "skipped": "Script deploy skipped",      // non eseguito su questa macchina (OS non compatibile o script in draft)
        "error": "Script deploy error"           // errore prima/durante l'avvio (start fallito, contenuto vuoto, eccezione)
    },
    get: function () {
        return {
            id: null,
            name: "",
            description: "",
            language: "powershell",
            status: "draft",
            tags: [],
            creds: [],

            content: "",
            args: [],
            os: "windows",

            //campi messi prima del salvataggio
            //owner:"",//nome dell'organizzazione dell'utente loggato
            //edited_by:"", // nome o id dell'utente loggato

            //campi recuperati in get
            //inserted_at:"",
            //updated_at:"",
        };
    },
    getScriptDeploy: function(idScript) {
        return {
            deploy: {
                id_script: idScript ?? '',
                name: ''
            },
            computer_ids: [],
            results:[]
        };
    }
}
